<template>
  <el-dialog class="addDialog" :visible.sync="addVisible" width="900px" :show-close="false"
             :close-on-press-escape="false" :close-on-click-modal="false">
    <div class="content-inner">
      <div class="l-inner">
        <div class="item">
          <div class="label-inner">请选择智能体性别</div>
          <el-select v-model="creatForm.six" size="medium">
            <el-option label="男" value="男"></el-option>
            <el-option label="女" value="女"></el-option>
          </el-select>
        </div>
        <!-- <div class="item">
          <div class="label-inner">请选择智能体语音</div>
          <el-select v-model="creatForm.audioId">
            <el-option v-for="item in audioList" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
          <span v-show="creatForm.audioId">
            <div class="play-icon el-icon-video-play" @click="playAudio">试听</div>
          </span>
        </div> -->
        <!-- <div class="item">
          <div class="label-inner">请设置问题数量</div>
          <el-input-number v-model="creatForm.num" :min="3" :max="15" :precision="0"></el-input-number>
        </div> -->
      </div>
      <div class="r-inner">
        <div class="label-inner">选择智能体形象</div>
        <div class="figureBox">
          <el-carousel ref="carousel" indicator-position="outside" :autoplay="false" height="480px">
            <el-carousel-item v-for="(item, index) in figureList" :key="index">
              <div class="figureItem">
                <img :src="item.img">
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <div class="footer-inner" slot="footer">
      <el-button type="primary" size="small" @click="handleAdd">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'creatDialog',
  data () {
    return {
      addVisible: false,
      creatForm: {
        six: '女',
        // audioId: '',
        num: 3
      }
    }
  },
  computed: {
    // 角色列表
    figureList () {
      if (this.creatForm.six == '男') {
        return this.$storeCase.man || []
      } else if (this.creatForm.six == '女') {
        return this.$storeCase.woman || []
      }
      return []
    },
    // 音频列表
    audioList () {
      // if (this.creatForm.six == '男') {
      //   return this.man.audio || []
      // } else if (this.creatForm.six == '女') {
      //   return this.woman.audio || []
      // }
      return []
    }
  },
  watch: {
    'addVisible' (newVal, oldVal) {
      if (newVal) {
        this.creatForm.num = 3
      } else {
        this.$emit('close')
      }
    },
    'creatForm.six' () {
      // this.creatForm.audioId = ''
    }
  },
  created () {

  },
  mounted () {

  },
  methods: {
    // 跳转：
    show () {
      this.addVisible = true
    },

    // 验证表单
    verify () {
      let data = this.creatForm
      for (let i in data) {
        if (!data[i]) {
          this.$message.warning('请完成创建输入项！')
          return
        }
      }
      return true
    },

    // 创建自定义
    handleAdd () {
      if (this.verify()) {
        this.$storeCase.initFigure({
          ...this.creatForm,
          index: this.$refs['carousel'].activeIndex,
        })
        this.addVisible = false
        this.$emit('change')
      }
    },

    // 播放语音Demo
    playAudio () {
      let id = this.creatForm.audioId
      let data = null
      this.audioList.some(item => {
        if (item.id == id) {
          data = item
          return true
        }
      })
      if (data && data.file) {
        var mp3 = new Audio(data.file)
        mp3.play && mp3.play()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.addDialog {
  backdrop-filter: blur(5px);

  /deep/ .el-dialog {
    border: 1px solid rgba(29, 156, 181, 0.3);
    padding: 0 20px;
    border-radius: 10px;
    background-color: #fff;

    .el-dialog__headerbtn {
      font-size: 20px !important;
    }
  }

  .content-inner {
    height: 500px;

    .label-inner {
      color: #fff;
      margin-bottom: 12px;
      font-size: 16px;
      user-select: none;
    }

    .l-inner {
      float: left;
      width: 40%;
      margin-right: 30px;
    }

    .item {
      margin-bottom: 30px;

      /deep/ textarea {
        resize: none;
      }

      .play-icon {
        margin-left: 15px;
        cursor: pointer;
        color: #33d5e7;

        &::before {
          font-size: 20px;
          margin-right: 2px;
          vertical-align: middle;
        }

        &:hover {
          color: #00c3ff;
        }
      }
    }

    .r-inner {
      /deep/ .el-carousel {
        .figureItem {
          height: 100%;

          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }

        .el-carousel__arrow {
          display: block !important;
          font-size: 25px;
        }

        .el-carousel__indicators {
          display: none;
        }
      }
    }
  }

  .footer-inner {
    text-align: center;

    .el-button {
      min-width: 120px;
      letter-spacing: 2px;
    }
  }
}
</style>